import { ServerError } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { Observable } from '@apollo/client/utilities';
import * as Sentry from '@sentry/browser';

function isUnauthorizedError(networkError: Error): networkError is ServerError {
  return networkError.name === 'ServerError' && (networkError as ServerError).statusCode === 401;
}

export const createErrorLink = (onUnauthenticatedError: () => Promise<void>) =>
  onError(({ forward, networkError, operation }) => {
    if (networkError) {
      if (isUnauthorizedError(networkError)) {
        // If the network error is a 401, we want to handle it by triggering the unauthenticated error handler.
        // This is an "expected" error in the sense that it indicates the user is not authenticated,
        // so we handle it differently than other errors, not capturing it with Sentry
        return new Observable(observer => {
          onUnauthenticatedError()
            .then(() => {
              observer.complete();
            })
            .catch(error => {
              observer.error(error);
            });
        });
      }

      Sentry.captureException(networkError);
    }

    return forward(operation);
  });
